import { useMemo } from 'react';
import { MdModeEditOutline } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { formatDate } from '../../utils/formatter';
import Button from '../shared/buttons/Button';
import Row from '../shared/table/Row';
import SelectableRow from '../shared/table/SelectableRow';
import Table from '../shared/table/Table';

const NotesTable = ({ notes, loading, onNoteClick, onNoteEditClick, readOnly, isPublic }) => {
  const isTabletView = useSelector((state) => state.screen.isTabletView);
  const tableRows = useMemo(
    () =>
      notes.map((note, i) => (
        <SelectableRow key={i} onClick={() => onNoteClick(note)}>
          <Row
            children=<span className="flex flex-col gap-1 py-1 md:py-2">
              <h3 className="font-extrabold">{note.title}</h3>
              <p className="text-xs text-gray-700">{!isTabletView ? note.preview : note.preview.substring(0, 80)}...</p>
            </span>
          />
          {isPublic && <Row children={note.createdBy} />}
          {!isTabletView && <Row children={formatDate(note.updatedAt)} />}
          {!readOnly && (
            <Row
              children={
                <div className="w-full flex justify-end gap-1 z-10">
                  <Button
                    title="Редагувати"
                    onClick={(event) => {
                      event.stopPropagation();
                      onNoteEditClick(note);
                    }}
                    variant="secondary2"
                    disabled={loading}
                  >
                    <MdModeEditOutline size={20} />
                  </Button>
                </div>
              }
            />
          )}
        </SelectableRow>
      )),
    [isTabletView, readOnly, onNoteEditClick, loading, notes, onNoteClick, isPublic],
  );

  return (
    <Table
      columns={isTabletView ? getMobileColumns(readOnly, isPublic) : getColumns(readOnly, isPublic)}
      data={tableRows}
    />
  );
};

const getColumns = (readOnly, isPublic) => {
  const cols = [{ name: 'Назва', className: isPublic ? 'w-[60%]' : 'w-[70%]' }];
  if (isPublic) {
    cols.push({ name: 'Автор', className: 'w-[20%]' });
  }
  cols.push({ name: 'Оновлено', className: 'w-[10%]' });
  if (!readOnly) {
    cols.push({ name: 'Дії', className: 'w-[5%] text-center' });
  }
  return cols;
};

const getMobileColumns = (readOnly, isPublic) => {
  const cols = [{ name: 'Назва', className: isPublic ? 'w-[50%]' : 'w-[70%]' }];
  if (isPublic) {
    cols.push({ name: 'Автор', className: 'w-[25%]' });
  }
  if (!readOnly) {
    cols.push({ name: 'Дії', className: 'w-[10%] text-center' });
  }
  return cols;
};

export default NotesTable;
